
import WkDistpicker from '../WkDistpicker';

import { isArray, isEmpty } from '@/utils/types';
import Emitter from 'element-ui/lib/mixins/emitter';

export default {
  // 地址
  name: 'WkPosition',

  components: {
    WkDistpicker: WkDistpicker
  },

  mixins: [Emitter],

  inheritAttrs: false,

  props: {
    hideArea: { type: Boolean, default: false },
    onlyProvince: { type: Boolean, default: false },
    showDetail: { type: Boolean, default: true },
    // eslint-disable-next-line vue/require-prop-types
    value: {
      required: true
    },
    disabled: Boolean
  },

  data: function data() {
    return {
      distpickerValue: [],
      detailAddress: '',
      dataValue: []
    };
  },


  computed: {},

  watch: {
    value: {
      handler: function handler(val) {
        if (!this.valueEquals(val, this.dataValue)) {
          this.getDefaultValue();
        }
      },

      immediate: true
    }
  },

  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  methods: {
    getDefaultValue: function getDefaultValue() {
      var _this = this;

      var value = isArray(this.value) ? this.value : [];

      var distpickerValue = [];
      var hasAddress = false;
      value.forEach(function (item) {
        if (item.id === 4) {
          hasAddress = true;
          _this.detailAddress = item.name;
        } else {
          distpickerValue.push(item);
        }
      });

      if (!hasAddress) {
        this.detailAddress = '';
      }

      this.distpickerValue = distpickerValue;
    },


    /**
     * 值更新
     */
    valueChange: function valueChange() {
      var dataValue = this.showDetail && isEmpty(this.detailAddress) ? this.distpickerValue : this.distpickerValue.concat([{
        code: '',
        name: this.detailAddress,
        id: 4
      }]);
      this.dataValue = dataValue;

      this.$emit('input', this.dataValue);
      this.$emit('change', this.dataValue);
      this.dispatch('ElFormItem', 'el.form.change', this.dataValue);
    },
    valueEquals: function valueEquals(a, b) {
      if (a === b) return true;
      if (!(a instanceof Array)) return false;
      if (!(b instanceof Array)) return false;
      if (a.length !== b.length) return false;
      for (var i = 0; i !== a.length; ++i) {
        var aValue = a[i];
        var bValue = b[i];
        if (aValue.id !== bValue.id || aValue.name !== bValue.name) return false;
      }
      return true;
    }
  }
};